import React, {Component} from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

const modalSpinnerStyle = {
    position: 'relative',
    top: '5px',
    right: '20px'
};

export default class Modal extends Component {

    componentWillReceiveProps(newProps) {
        if (newProps.visible) {
            $('body').addClass('modal-open');
        } else {
            $('body').removeClass('modal-open');
        }
    }

    render() {
        if (this.props.visible) {
            return (
                <div>
                    <div className="modal modal-open" style={{display: 'block', paddingLeft: '0'}} tabIndex="-1" onClick={this.props.onClose}>
                        <div className="modal-dialog" onClick={e => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={this.props.onClose}>
                                        <span>&times;</span>
                                    </button>
                                    <h4 className="modal-title">{this.props.title}</h4>
                                </div>
                                <div className="modal-body">
                                    {this.props.children}
                                </div>
                                <div className="modal-footer">
                                    {this.props.isLoading && this.props.isLoading() ? <span className="spinner" style={modalSpinnerStyle}/> : undefined}
                                    {!this.props.isLoading || !this.props.isLoading() ?
                                        <button type="button"
                                            className="btn btn-primary"
                                            disabled={this.props.isValid && !this.props.isValid()}
                                            onClick={this.props.onSubmit}>{this.props.submitText || 'Submit'}</button> : undefined}
                                    <button type="button" className="btn btn-default" onClick={this.props.onClose}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop" style={{opacity: '0.5'}} onClick={() => console.log('close bd ?')}/>
                </div>
            );
        } else {
            return <span/>;
        }
    }
}

Modal.propTypes = {
    visible: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    submitText: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isValid: PropTypes.func,
    isLoading: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/modal.js